import jwt_decode from "jwt-decode";
import _ from "underscore";
import axiosInstance from "../api";

export const SESSION_TOKEN = 'fmap-session-token';
export const SESSION_USER = 'fmap-user';
export const SESSION_SNACKBAR_MESSAGE = 'fmap-snackbar-message';

export function isSessionValid() {

    const sessionToken = sessionStorage.getItem(SESSION_TOKEN);
    if (sessionToken) {
        const parts = sessionToken.split(':');
        const expireTime = Number(parts[1]);
        const currentTime = new Date().getTime();

        return expireTime >= currentTime;
    }

    return false;
}

export function setSessionToken(sessionToken) {
    console.log("setSessionToken", sessionToken);
    sessionStorage.setItem(SESSION_TOKEN, sessionToken);
}

export function setSessionUser(user) {
    const serializedUser = JSON.stringify(user);
    sessionStorage.setItem(SESSION_USER, serializedUser);
}

export const setSnackBarMessage = (message) => {
    sessionStorage.setItem(SESSION_SNACKBAR_MESSAGE, message);
}

export const getSnackBarMessage = () => {
    return sessionStorage.getItem(SESSION_SNACKBAR_MESSAGE);
}


export function getSessionUser() {
    let user = {};
    const sessionUser = sessionStorage.getItem(SESSION_USER);
    if (_.isNull(sessionUser)) {
        const sessionUser = sessionStorage.getItem("fmap-token");
        if (!_.isNull(sessionUser)) {
            let decodedToken = jwt_decode(sessionUser);
            user = {
                firstName: decodedToken.app.fname,
                lastName: decodedToken.app.lname,
                hasSysAccess: decodedToken.app.hasSysAccess,
                username: decodedToken.app.userName,
                cagId: decodedToken.app.cagId,
                fmapRole: decodedToken.app.fmapRole,
                userId: decodedToken.app.userId,
                agentId: decodedToken.app.agentId,
                locked: decodedToken.app.locked
            };
        } else {
            return user;
        }

        return user;
    }
    user = JSON.parse(sessionUser);
    /*const sessionUser = sessionStorage.getItem(SESSION_USER);
    if ( sessionUser === null ) {
        user = {userId: 0, username: '', email: '', sessionToken: '', languageCode: '', userType: ''};
        return user;
    }

    user = JSON.parse(sessionUser);*/

    return user;
}

export function removeSession() {
    sessionStorage.removeItem(SESSION_TOKEN);
    sessionStorage.removeItem(SESSION_USER);
    localStorage.removeItem('fmap-token');
    axiosInstance.defaults.headers.common['Authorization'] = '';
}

export function isTokenValid() {
    let token = sessionStorage.getItem(SESSION_TOKEN);
    if (null != token) {
        let decodedToken = jwt_decode(token);
        let currentDate = new Date() / 1000;
        return decodedToken.exp > currentDate;
    } else {
        return false;
    }
}

export function doesTokenExists() {
    let token = sessionStorage.getItem(SESSION_TOKEN);
    return !(token === null || token === undefined || token.trim() === '');

}

export function logout() {
    localStorage.removeItem('fmap-token');
}

